// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Moment } from 'moment';
import type { IAttributeTypeMap, RequestFile } from '@trialcard/shared';

export class TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewResponse {
    /**
    * @description Url
    */
    'url': string;

    static readonly discriminator: string | undefined = undefined;

    static readonly additionalProperties = false;

    
    static readonly attributeTypeMap: ReadonlyArray<IAttributeTypeMap<keyof TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewResponse>> = [
        {
            "name":     "url",
            "baseName": "url",
            "type":     "string"
        },
    ];

    static getAttributeTypeMap() {
        return TCQpSignatureServiceRequestGetRecipientViewGetRecipientViewResponse.attributeTypeMap;
    }
}
